import { AddDispatcherDto } from "./addDispatcherDto";
import { EditDispatcherDto } from "./editDispatcherDto";
import { DispatcherDetailsDto } from "./dispatcherDetailsDto";
import { Gender } from "../enums/gender";
import { DispatcherCapabilityType } from "../enums/dispatcherCapabilityType";

export interface EditDispatcherFormDto {
  id?: number;
  userId?: number;
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  phoneNumber: string;
  gender: Gender | '';
  isDismissed: boolean;
  companyIds: number[];
  notificationTypeIds?: number[];
  photoFile?: File;
  photoUrl?: string;
  esiaId?: string;
  capabilities: DispatcherCapabilityType[];
}

export const emptyEditDispatcherFormDto = (companyId?: number): EditDispatcherFormDto => {
  return {
    firstName: '',
    lastName: '',
    middleName: '',
    email: '',
    phoneNumber: '',
    gender: '',
    isDismissed: false,
    companyIds: companyId ? [companyId] : [],
    notificationTypeIds: [4], // Default to "Направления по давлению" (ID: 4)
    photoFile: undefined,
    photoUrl: undefined,
    capabilities: [],
  }
};

export const mapToAddDispatcherDto = (formData: EditDispatcherFormDto): AddDispatcherDto => {
  return {
    firstName: formData.firstName,
    lastName: formData.lastName,
    middleName: formData.middleName,
    email: formData.email!,
    phoneNumber: formData.phoneNumber,
    gender: formData.gender,
    companyIds: formData.companyIds,
    notificationTypeIds: formData.notificationTypeIds,
    photoFile: formData.photoFile,
  }
};

export const mapToEditDispatcherDto = (formData: EditDispatcherFormDto): EditDispatcherDto => {
  return {
    id: formData.id!,
    userId: formData.userId!,
    firstName: formData.firstName,
    lastName: formData.lastName,
    middleName: formData.middleName,
    email: formData.email!,
    phoneNumber: formData.phoneNumber,
    gender: formData.gender,
    isDismissed: formData.isDismissed,
    companyIds: formData.companyIds,
    notificationTypeIds: formData.notificationTypeIds,
    photoFile: formData.photoFile,
    photoUrl: formData.photoUrl,
    esiaId: formData.esiaId,
    capabilities: formData.capabilities,
  }
};

export const mapToEditDispatcherFormDto = (dto: DispatcherDetailsDto): EditDispatcherFormDto => {
  return {
    id: dto.id!,
    userId: dto.userId!,
    firstName: dto.firstName,
    lastName: dto.lastName,
    middleName: dto.middleName,
    email: dto.email!,
    phoneNumber: dto.phoneNumber,
    gender: dto.gender,
    isDismissed: dto.isDismissed,
    companyIds: dto.companies ? dto.companies.map(d => d.id) : [],
    notificationTypeIds: dto.notificationTypes ? dto.notificationTypes.map(d => d.id) : [],
    photoUrl: dto.photoUrl,
    esiaId: dto.esiaId,
    capabilities: dto.capabilities ?? [],
  }
};
